const carouselItems = [
  {
    title: '韩漫精选 · 恋爱甜宠特辑',
    desc: '精选10部高分韩漫恋爱作品，从校园到职场，从纯爱到虐恋，总有一部戳中你。虫虫漫画韩漫区口碑最高的甜蜜合集，一次看个够。',
    tag: '韩漫特辑',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20webtoon%20style%20banner%2C%20a%20couple%20under%20cherry%20blossoms%20with%20soft%20pink%20and%20coral%20tones%2C%20dreamy%20atmosphere%2C%20delicate%20manhwa%20art%20style%2C%20clean%20cream%20background%2C%20editorial%20layout%20with%20wide%20horizontal%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '日漫经典 · 悬疑推理精选',
    desc: '虫虫漫画日漫悬疑区必读榜单，从本格推理到社会派悬疑，烧脑剧情让你欲罢不能。下拉式阅读让每一话的悬念衔接更加紧凑刺激。',
    tag: '日漫精选',
    tagColor: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20Japanese%20manga%20style%20wide%20banner%2C%20shadowy%20figure%20in%20a%20library%20with%20clues%20and%20magnifying%20glass%2C%20warm%20sepia%20and%20amber%20tones%2C%20atmospheric%20noir%20lighting%2C%20detailed%20line%20art%2C%20cinematic%20wide%20composition&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国漫崛起 · 玄幻热血合集',
    desc: '虫虫漫画国漫区精选玄幻热血作品合集，从剑道修行到仙侠江湖，国产漫画正在用惊艳的画风和扎实的剧情征服新一代读者。',
    tag: '国漫合集',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20banner%2C%20a%20hero%20with%20flowing%20robes%20on%20a%20misty%20mountain%2C%20warm%20golden%20sunset%20light%2C%20ink%20wash%20painting%20style%2C%20epic%20and%20heroic%20mood%2C%20wide%20panoramic%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '完结推荐 · 一口气看完系列',
    desc: '不想追更等更新？虫虫漫画精选10部已完结高分漫画，剧情完整、画风一流，从第一话看到最后一话，下拉式阅读让你爽到停不下来。',
    tag: '完结推荐',
    tagColor: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20completed%20manga%20books%20stacked%20neatly%20on%20a%20wooden%20desk%2C%20warm%20cozy%20reading%20nook%20atmosphere%2C%20soft%20amber%20lighting%2C%20modern%20flat%20illustration%20style%2C%20comfortable%20and%20inviting%20mood%2C%20wide%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '新作速递 · 本月最值得追的新番',
    desc: '虫虫漫画本月新上线的10部潜力新作，涵盖恋爱、悬疑、搞笑等多种题材，编辑精选推荐，快来看看有没有你的新心头好。',
    tag: '新作速递',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20new%20comic%20book%20covers%20displayed%20in%20a%20gallery%20style%2C%20fresh%20and%20vibrant%20artwork%2C%20warm%20peach%20and%20coral%20accents%2C%20modern%20minimal%20aesthetic%2C%20clean%20cream%20background%2C%20editorial%20wide%20layout&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
  {
    title: '读者票选 · 年度最受欢迎漫画TOP10',
    desc: '虫虫漫画读者票选年度人气漫画榜单揭晓！韩漫、日漫、国漫混排比拼，看看你喜欢的作品排第几，有没有遗珠之作等你发现。',
    tag: '年度票选',
    tagColor: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Award%20ceremony%20style%20banner%20with%20trophy%20and%20comic%20book%20silhouettes%2C%20warm%20golden%20spotlight%20effect%2C%20elegant%20and%20celebratory%20atmosphere%2C%20soft%20cream%20background%2C%20modern%20illustration%20style%2C%20wide%20horizontal%20composition&width=1200&height=600&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500">虫虫漫画精选专题合集，发现更多值得一看的好作品</p>
        </div>

        <div className="flex flex-col gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer group flex flex-col sm:flex-row"
            >
              <div className="w-full sm:w-[280px] md:w-[340px] flex-shrink-0 aspect-[2/1] sm:aspect-auto overflow-hidden">
                <img
                  src={item.image}
                  alt={`虫虫漫画焦点专题 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`虫虫漫画专题：${item.title}`}
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
                      item.tagColor === 'primary'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-accent-100 text-accent-700'
                    }`}
                  >
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}